import React, { useState, useEffect } from "react";
import { DNA } from "react-loader-spinner";

const funFacts = [
  "Bacteria have a single oriC origin, yet they copy DNA unbelievably fast and efficiently.",
  "E. coli finishes DNA replication in ~40 minutes, but can divide roughly every 20 minutes.",
  "DNA polymerase III drives bacterial replication with extreme speed and impressive accuracy.",
  "The oriC region is rich in A–T bases, which separate easier because they form fewer bonds.",
  "Most bacterial chromosomes are circular, forming a continuous loop instead of linear ends.",
  "E. coli has ~4,400 genes; humans have ~20,000, yet bacteria dominate ecosystems globally.",
  "Bacteria make up more total biomass on Earth than all plants and animals combined do.",
  "DnaA protein binds DnaA boxes in oriC, kickstarting the entire DNA replication process.",
  "Most bacteria use one oriC, though a few species evolved multiple replication start sites.",
  "DNA polymerase proofreads DNA and makes about one error per ten million incorporated bases.",
  "Bacteria replicate continuously — there are no breaks or weekends inside a growing cell.",
  "DNA polymerase acts like nature’s fastest copy machine, working with great precision.",
  "The oriC region serves as a molecular start button to launch DNA copying in bacteria.",
  "Some bacteria grow so rapidly that they can copy DNA and divide in under twenty minutes.",
  "Replication forks move in opposite directions from oriC, racing around the chromosome.",
];


function Loading() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((i) => (i + 1) % funFacts.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="loading-screen">
      <div className="loading-box">
        <DNA visible={true} height="120" width="120" ariaLabel="dna-loading" />
        <p className="loading-fact">{funFacts[count]}</p>
      </div>
    </div>
  );
}

export default Loading;
